import React from "react";
import { AppContentKasir } from "../components/index";

const KasirLayout = () => {
  return (
    <>
      <div className="wrapper d-flex flex-column bg-light dark:bg-transparent">
        {/* <HeaderWaitress /> */}
        <div className="body">
          <AppContentKasir />
        </div>
      </div>
    </>
  );
};

export default KasirLayout;
